export const MOTIVOS_COLABORADORES = [
  "Atestado Médico",
  "Atestado Odontológico",
  "Declaração / Atestado de comparecimento",
  "Luto (falecimento de familiar)",
  "Doação de sangue",
  "Licença maternidade / paternidade",
  "Convocação judicial ou militar",
  "Representação sindical",
  "Acidente de trabalho",
  "Outros",
];

export default MOTIVOS_COLABORADORES;
